import { c as _c } from "react/compiler-runtime";
import { PayPalScriptProvider, PayPalMessages } from '@paypal/react-paypal-js';
type PayPalMessageProps = {
  amount: number;
};
const sdkInitOptions = {
  clientId: 'AUpAvpKrczpE81Qny4K1I0NqWgZXj1b1iLsjqAJMBBweHW3mISiwIoersCV266MPBHxsB-Ch4DyP5lVo',
  currency: 'EUR',
  components: 'messages'
};
export const PayPalMessage = t0 => {
  const $ = _c(3);
  const {
    amount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      layout: "text",
      text: {
        size: 14
      },
      logo: {
        type: "alternative"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== amount) {
    t2 = <PayPalScriptProvider options={sdkInitOptions}><PayPalMessages style={t1} amount={amount} /></PayPalScriptProvider>;
    $[1] = amount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};